<template>
    <div>
        <component :is="blockComponent" :block-data="block" :project="project"></component>
        <hr>
        <h3>Einstellung zum Onlinestatus</h3>
        <GeneralBlock :block-data="block"></GeneralBlock>
    </div>
</template>
<script>
import ChartBlock from "../../../components/Blocks/ChartBlock";
import ContactBlock from "../../../components/Blocks/ContactBlock";
import FilmBlock from "../../../components/Blocks/FilmBlock";
import ImageBlock from "../../../components/Blocks/ImageBlock";
import ImageGalleryBlock from "../../../components/Blocks/ImageGalleryBlock";
import IntroductionBlock from "../../../components/Blocks/IntroductionBlock";
import KeyResultsBlock from "../../../components/Blocks/KeyResultsBlock";
import ProjectProductsBlock from "../../../components/Blocks/ProjectProductsBlock";
import QuotationBlock from "../../../components/Blocks/QuotationBlock";
import GeneralBlock from "../../../components/Blocks/GeneralBlock";
import ResumeeBlock from "../../../components/Blocks/ResumeeBlock";

export default {
  props: ["data"],
  data() {
    return {
      project: this.data
    };
  },
  components: {
    GeneralBlock,
    ChartBlock,
    ContactBlock,
    FilmBlock,
    ImageBlock,
    ImageGalleryBlock,
    IntroductionBlock,
    KeyResultsBlock,
    ProjectProductsBlock,
    QuotationBlock,
    ResumeeBlock
  },
  computed: {
    block() {
      for (let block of this.project.blocks) {
        if (block.id == this.$route.params.blockId) {
          return block;
        }
      }
    },
    blockComponent() {
      return this.block.class;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/admin/block/Edit.vue